import React from 'react';


class HeaderCell extends React.Component {
    render() {
        // Build Header Cell with title info
        return (
            <th className={this.props.column}>
                {this.props.value}
            </th>
        );
    }
}

export default HeaderCell;